module.exports = "https://static.zego.com/_next/static/images/iPhone-5f2d9a859ff368bb0ed31fa138ba7116.svg";